const ltr1 = "aeiou";
const ltr2 = "bcdfghjklmnprstvz";

function rndChar(s) {
	return s.charAt(Math.random() * s.length);
}

export function generateCode() {
	return rndChar(ltr2) + rndChar(ltr1) + rndChar(ltr2) + rndChar(ltr1) + rndChar(ltr2);
}
